export default __webpack_public_path__ + "89e84de1275d025f08736b8037cc9e21.jpg";